<template>
	<van-nav-bar :title="title" :left-arrow="$route.meta.headReturn" fixed
		@click-left="onBack" >
	</van-nav-bar>

<!-- @click-right="onHome">
		<template #right v-if="$route.meta.headReturn">
			<van-icon name="wap-home-o" size="18" />
		</template> -->
</template>

<script>
	import {
		NavBar
	} from 'vant';

	export default {
		name: 'headerNav',
		components: {
			[NavBar.name]: NavBar,
		},
		props: {
			title: String,
		},
		methods: {
			onBack() {
				history.back();
			},
			onHome() {
				this.$router.push('/home');
			},
		}
	}
</script>

<style>
	.van-nav-bar {
		height: 46px !important;
		line-height: 46px !important;
	}
</style>
